import { render } from "./cartOverview.vue?vue&type=template&id=ddb6f31a&ts=true"
import script from "./cartOverview.vue?vue&type=script&lang=ts"
export * from "./cartOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__